var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathAdobeXd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7504 119H21.2496C9.4992 119 0 109.501 0 97.7504V23.2496C0 11.4992 9.4992 2 21.2496 2H98.7504C110.501 2 120 11.4992 120 23.2496V97.7504C120 109.501 110.501 119 98.7504 119Z",
    fill: "#FF26BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.85 113.998H23.1508C13.1524 113.998 5.00195 105.848 5.00195 95.8495V25.1503C5.00195 15.1519 13.1524 7.00146 23.1508 7.00146H96.802C106.853 7.00146 114.951 15.1519 114.951 25.1503V95.8015C114.999 105.848 106.848 113.998 96.85 113.998Z",
    fill: "#2E001F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4483 56.749L61.4499 83.6482C61.6995 84.0466 61.5507 84.4498 61.1475 84.4498H52.4451C51.8931 84.4498 51.6435 84.301 51.3939 83.8018C48.1923 77.2018 44.9427 70.6018 41.5923 63.5026H41.4915C38.4915 70.2034 35.1891 77.2546 31.9923 83.8546C31.7427 84.253 31.4931 84.4066 31.0899 84.4066H22.8483C22.3491 84.4066 22.2963 84.0082 22.5507 83.7058L36.2499 57.6034L23.0019 31.2034C22.6995 30.805 23.0019 30.5026 23.2995 30.5026H31.9011C32.4003 30.5026 32.6019 30.6034 32.7987 31.0546C35.9475 37.6546 39.1491 44.4562 42.1491 51.1042H42.2499C45.1491 44.5042 48.3507 37.6546 51.4515 31.1026C51.7011 30.7042 51.8499 30.4546 52.3539 30.4546H60.4035C60.8019 30.4546 60.9555 30.757 60.7059 31.1554L47.4483 56.749ZM63.9027 64.8994C63.9027 53.2498 71.6547 44.149 83.9523 44.149C85.0035 44.149 85.5507 44.149 86.5539 44.2498V31.0018C86.5539 30.6994 86.8035 30.5026 87.0531 30.5026H94.9539C95.3523 30.5026 95.4531 30.6514 95.4531 30.901V76.8034C95.4531 78.1522 95.4531 79.8514 95.7027 81.7042C95.7027 82.0066 95.6019 82.1026 95.3043 82.2562C91.1043 84.2578 86.7027 85.1554 82.5027 85.1554C71.6499 85.1986 63.8979 78.5026 63.9027 64.8994ZM86.5491 52.1026C85.8483 51.8002 84.8499 51.6034 83.6499 51.6034C77.3475 51.6034 72.9507 56.4514 72.9507 64.5058C72.9507 73.7074 77.4531 77.4082 83.1027 77.4082C84.3027 77.4082 85.6035 77.2594 86.5539 76.8562V52.1026H86.5491Z",
    fill: "#FFD9F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 117,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathAdobeXd);
export default __webpack_public_path__ + "static/media/path-adobe-xd.822e1879f3a67279750ab60d267df41b.svg";
export { ForwardRef as ReactComponent };